<template>
  <div
    class="content_main rounded-0 pt-content position-relative"
    :class="{'bg_c9': !isThaiCharoenPlus}"
    style="margin-top: -50px"
  >
    <div class="container">
      <div class="row">
        <div
          class="col-12 mt-4 mb-5 animateMe"
          data-animation="fadeInUp"
          @click="goTo(ROUTE_INTERNAL_LOTTO)"
        >
          <div class="box-huay hover-scale">
            <div 
              class="img"
              :class="{
                'img-box-huay-jj': isJertjarat,
              }"
            >
              <img
                v-if="isJertjarat"
                src="@/assets/v3/n/game-jj/h-1.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/v3/n/menu-huay.png"
                alt=""
              />
            </div>
            <div class="txt">
              <h2
                class="t-semibold  white--text"
                :class="{
                  'lotto--text-jj': isJertjarat,
                }"
              >
                แทงหวยออนไลน์
              </h2>
            </div>
          </div>
        </div>

        <div
          class="col-4 animateMe"
          data-animation="fadeInUp"
          @click="goTo(ROUTE_GAME_TYPE, { type: CASINO })"
        >
          <div
            class="hover-scale box-g bg_c35"
          >
            <div class="img">
              <img
                v-if="isJertjarat"
                src="@/assets/v3/n/game-jj/c-1.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/v3/n/menu-casino.png"
                alt=""
              />
            </div>
            <div class="txt white--text">
              <h1 class="t-regular">
                คาสิโน
              </h1>
            </div>
          </div>
        </div>

        <div
          class="col-4 animateMe"
          data-animation="fadeInUp"
          @click="goTo(ROUTE_GAME_TYPE, { type: SLOT })"
        >
          <div
            class="hover-scale box-g bg_c36"
          >
            <div class="img">
              <img
                v-if="isJertjarat"
                src="@/assets/v3/n/game-jj/s-1.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/v3/n/menu-slot.png"
                alt=""
              />
            </div>
            <div class="txt white--text">
              <h1 class="t-regular">
                สล็อต
              </h1>
            </div>
          </div>
        </div>

        <div
          class="col-4 animateMe"
          data-animation="fadeInUp"
          @click="goTo(ROUTE_GAME_TYPE, { type: SPORT })"
        >
          <div
            class="hover-scale box-g bg_c37"
          >
            <div class="img">
              <img
                v-if="isJertjarat"
                src="@/assets/v3/n/game-jj/sp-1.png"
                alt=""
              />
              <img
                v-else
                src="@/assets/v3/n/menu-sport.png"
                alt=""
              />
            </div>
            <div class="txt white--text">
              <h1 class="t-regular">
                กีฬา
              </h1>
            </div>
          </div>
        </div>

        <div
          class="col-12 animateMe"
          data-animation="fadeInUp"
        >
          <div class="p-menu-list">
            <template v-if="showCustomMenu">
              <div 
                v-for="(item, i) in jjItems"
                :key="i"  
                class="p-menu-item"
                @click="goTo(item.routeName)"
              >
                <div
                  class="hover-scale"
                >
                  <img
                    :src="item.link"
                  />
                </div>
              </div>
            </template>
            <template v-else>
              <div 
                v-for="(item, i) in items"
                :key="i"  
                class="p-menu-item"
                @click="goTo(item.routeName)"
              >
                <div
                  class="p-menu-link hover-scale box_shadow"
                >
                  <div class="img">
                    <img
                      :src="item.link"
                    />
                  </div>
                  <h5 class="mt-4 menu-list-name">
                    {{ $t(item.name) }}
                  </h5>
                </div>
              </div>
            </template>
            
            <div 
              v-if="wallet.is_can_spinwheel"
              class="p-menu-item"
              @click="openRoulete"
            >
              <div
                class="p-menu-link hover-scale box_shadow"
              >
                <div class="img">
                  <img
                    src="@/assets/v3/n/menu-spin.png"
                  />
                </div>
                <h5 class="mt-4">
                  ลุ้นกงล้อ
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dialog-roulete ref="roulete" />
  </div>
</template>
<script>
import { ROUTE_INTERNAL_LOTTO, ROUTE_CREDIT, ROUTE_LIST, ROUTE_TRASACTION, ROUTE_RESULT, ROUTE_AFFILIATE, ROUTE_CASHBACK, ROUTE_GAME_TYPE } from '@/const/route'
import dialogRoulete from '@/components/Dialog/DialogRouleteV2'

const CASINO = 2
const SPORT = 3
const SLOT = 4

export default {  
  components : {
    dialogRoulete
  },

  data: () => ({
    items: [
      {
        link: require('@/assets/v3/n/menu-report.png'),
        name: 'title.credit-report',
        routeName: ROUTE_CREDIT
      },
      {
        link: require('@/assets/v3/n/menu-list.png'),
        name: 'รายการโพย',
        routeName: ROUTE_LIST
      },
      {
        link: require('@/assets/v3/n/menu-depo.png'),
        name: 'title.transaction-report',
        routeName: ROUTE_TRASACTION
      },
      {
        link: require('@/assets/v3/n/menu-history.png'),
        name: 'ดูผลย้อนหลัง',
        routeName: ROUTE_RESULT
      },
      {
        link: require('@/assets/v3/n/menu-af.png'),
        name: 'title.affiliate',
        routeName: ROUTE_AFFILIATE
      },
      {
        link: require('@/assets/v3/n/menu-cashback.png'),
        name: 'แคชแบค',
        routeName: ROUTE_CASHBACK
      },
      // {
      //   link: require('@/assets/v3/n/menu-voucher.png'),
      //   name: 'voucher',
      //   routeName: ROUTE_VOUCHER
      // },
    ],
    jjItems: [
      {
        link: require('@/assets/v3/n/jj/credit.png'),
        name: 'title.credit-report',
        routeName: ROUTE_CREDIT
      },
      {
        link: require('@/assets/v3/n/jj/list.png'),
        name: 'รายการโพย',
        routeName: ROUTE_LIST
      },
      {
        link: require('@/assets/v3/n/jj/bank.png'),
        name: 'title.transaction-report',
        routeName: ROUTE_TRASACTION
      },
      {
        link: require('@/assets/v3/n/jj/result.png'),
        name: 'ดูผลย้อนหลัง',
        routeName: ROUTE_RESULT
      },
      {
        link: require('@/assets/v3/n/jj/af.png'),
        name: 'title.affiliate',
        routeName: ROUTE_AFFILIATE
      },
      {
        link: require('@/assets/v3/n/jj/cashback.png'),
        name: 'แคชแบค',
        routeName: ROUTE_CASHBACK
      },
      // {
      //   link: require('@/assets/v3/n/menu-voucher.png'),
      //   name: 'voucher',
      //   routeName: ROUTE_VOUCHER
      // },
    ]
  }), 
  computed : { 
    ROUTE_INTERNAL_LOTTO: () => ROUTE_INTERNAL_LOTTO,
    CASINO: () => CASINO,
    SPORT: () => SPORT,
    SLOT: () => SLOT,
    ROUTE_GAME_TYPE: () => ROUTE_GAME_TYPE,
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    showCustomMenu () {
      return  this.isJertjarat
    }
  },   

  methods: {  
     goTo (name, query = {}) { 
      this.$router.push({ name, query: query }).catch(()=>{}); 
    },
    openRoulete () {
      this.$refs.roulete.open()
    }
  }
}
</script>
<style scoped>
.content_main {
  height: 100%;
  border-radius: 20px 20px 0 0;
}

.pt-content {
  padding-top: 60px;
}

.bg_c9 {
  background: var(--v3-sec-color-20);
}

.bg_c35 {
  background: linear-gradient(100deg, #f1e03c 0%, #ff652a 100%);
}

.bg_c36 {
  background: linear-gradient(100deg, #d21c41 0%, #c8227e 100%);
}

.bg_c37 {
  background: linear-gradient(100deg, #4cecc2 0%, #813ec2 100%);
}


.box_shadow {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

.box-huay {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: linear-gradient(180deg, var(--v3-base-color-15-main) 0%, var(--v3-base-color-5-main) 70%);
  padding: 10px;
}
.box-huay .txt {
  padding: 0 20px;
}

.box-g {
  border-radius: 48px 13px 13px 7px;
  padding: 20px 10px 20px 10px;
  position: relative;
  height: 100%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.box-g .img {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-20%, -20%);
}
.box-g .txt {
  text-align: center;
}

.p-menu-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
  border-radius: 10px;
  background: linear-gradient(90deg, var(--v3-sec-color-35) 0%, var(--v3-sec-color-35) 100%);
  color: #0d6efd;
}
.p-menu-list .p-menu-item {
  width: calc(12.5% - 10px);
  margin: 5px;
  cursor: pointer;
}
.p-menu-list .p-menu-item .p-menu-link {
  width: 100%;
  height: 100%;
  background: var(--v3-sec-color-30);
  border-radius: 20px;
  padding: 10px 0;
  text-align: center;
}
.p-menu-list .p-menu-item .p-menu-link .img {
  width: 44px;
  margin: 0 auto;
  margin-bottom: -20px;
}

img {
  width: 100%;
}

.img-box-huay-jj {
  width: 140px;
  margin-top: -40px;
  margin-right: -30px;
}

@media only screen and (max-width: 992px) {
  .p-menu-list .p-menu-item {
    width: calc(25% - 10px);
  }
}

@media only screen and (max-width: 767px) {
  .box-g {
    padding: 40px 5px 20px 5px;
    border-radius: 7px 48px 13px 13px;
  }
  .box-g .img {
    width: 60px;
    height: 60px;
    left: auto;
    right: 0;
    transform: translate(20%, -20%);
  }
  .box-g .txt h1 {
    font-size: 18px;
  }
  .box-g .txt h3 {
    font-size: 14px;
  }

  .p-menu-list .p-menu-item {
    width: calc(33.33% - 10px);
  }

  .img-box-huay-jj {
    width: 100px;
  }
  
  .lotto--text-jj {
    margin-right: 0;
    font-size: 1.4rem;
  }
}

.hover-scale {
  transition: all 0.3s;
}
.hover-scale:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.menu-list-name {
  color: var(--v3-select-main-100);
}
</style>